/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group, {GroupHead} from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Prompt from "../../../Components/Prompt";
import Button from "../../../Components/Control/Button";
import ModalAwaitingRequests from "../../Modal/ModalAwaitingRequests";
import Resource from "../../../Resource";
import {connect} from "react-redux";
import ModalRequestProducts from "../../Modal/ModalRequestProducts";
import Org from "../../../Server/Org";
import Notif from "../../../Components/Notif";
import Perms from '../../../Perms';
import {Tool} from "../../../App";
import {OrganizationOrgEmerRequest} from "../../../Server/OrgEmerRequest";
import ModalOrgEmerRequest from "../../Modal/ModalOrgEmerRequest";

class PageOrgEmerRequests extends Component {
    constructor(props) {
        super(props);

        this.perms = Perms();

        if (!this.perms.ORG_EMER_REQUESTS.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    field: 'hospitalFullName',
                    headerName: 'نام بیمارستان',
                    headerTooltip: 'نام بیمارستان',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                }, {
                    field: 'hospitalShortName',
                    headerName: 'نام کوتاه بیمارستان',
                    headerTooltip: 'نام کوتاه بیمارستان',
                    hide: true
                }, {
                    field: 'totalProductCount',
                    headerName: 'تعداد کل درخواست',
                    headerTooltip: 'تعداد کل درخواست'
                }, {
                    field: 'orgSenderUserFullName',
                    headerName: 'نام درخواست کننده',
                    headerTooltip: 'نام درخواست کننده',
                    cellRenderer: row => row.data.orgSenderUserFullName || '-'
                }, {
                    field: 'createDateTime',
                    headerName: 'تاریخ درخواست',
                    headerTooltip: 'تاریخ درخواست',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'orgReceiverUserFullName',
                    headerName: 'نام دریافت کننده',
                    headerTooltip: 'نام دریافت کننده',
                    cellRenderer: row => row.data.orgReceiverUserFullName || '-'
                }, {
                    field: 'orgReceiveDateTime',
                    headerName: 'تاریخ درخواست',
                    headerTooltip: 'تاریخ درخواست',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'statusStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state'
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 110,
                    // hide: !(this.Perms().ORG_EMER_REQUESTS.VIEW || this.Perms().EDIT_ALL_SECTION_REQUEST || this.Perms().DELETE_SECTION_REQUEST),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {/* ارسال شده به بیمارستان*/}
                            {row.data.statusId == 62 && <GridState theme={'green'}>{row.data.statusStr}</GridState>}
                            {/*تحویل داده شده به بیمارستان*/}
                            {row.data.statusId == 65 && <GridState theme={'blue'}>{row.data.statusStr}</GridState>}
                            {![62, 65].includes(row.data.statusId) && <GridState theme={'green'}>{row.data.statusStr}{row.data.statusId}</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {this.perms.ORG_EMER_REQUESTS.VIEW && <GridButton type={"button"} theme={'view'} title={'مشاهده'} onClick={this.view.bind(this, row.data)}/>}
                            {this.perms.ORG_EMER_REQUESTS.ADD_PRODUCT && <GridButton type={"button"} theme={'blue'} title={'آماده سازی درخواست'} icon={Resource.IMAGE.PACK.MENU2.WHITE} onClick={this.ready.bind(this, row.data)}/>}
                            {this.perms.ORG_EMER_REQUESTS.DELIVERY && <GridButton type={"button"} theme={'blue'} title={'تحویل فرآورده به بیمارستان'} icon={Resource.IMAGE.PACK.REPLY.WHITE} onClick={this.deliver.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'مشاهده درخواست',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EYE.BLACK}" alt="">`,
                            disabled: !this.perms.ORG_EMER_REQUESTS.VIEW,
                            action: this.view.bind(this, params.node.data)
                        }, {
                            name: 'آماده سازی درخواست',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.MENU2.BLACK}" alt="">`,
                            disabled: !this.perms.ORG_EMER_REQUESTS.ADD_PRODUCT,
                            action: this.ready.bind(this, params.node.data)
                        }, {
                            name: 'تحویل فرآورده به بیمارستان',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.REPLY.BLACK}" alt="">`,
                            disabled: !this.perms.ORG_EMER_REQUESTS.DELIVERY,
                            action: this.deliver.bind(this, params.node.data)
                        },
                            'separator',
                            ...params.defaultItems];
                },
                onRowDoubleClicked: row => {
                    this.ref.modalOrgEmerRequest.current.open();
                },
                help: () => {
                    return <div>
                        {/*<div className={'Help-block'}>*/}
                        {/*    <div className={'pad-10 fb-20 dis-f'}>*/}
                        {/*<h3 className={'help-title'}>رنگ‌ها:</h3>*/}
                        {/*<p className={'help-back-gre mar-b-4'}>نشان دهنده گروه خونی فرآورده می باشد.</p>*/}
                        {/*<p className={'help-back-yel'}>نشان دهنده درخواست‌‌های حاوی فرآورده با گروه خونی منفی می باشد.</p>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className={'Help-block'}>*/}
                        {/*    <div className={'pad-10 fb-20 dis-f'}>*/}
                        {/*        <h3 className={'help-title'}>وضعیت‌ها:</h3>*/}
                        {/*        <p><GridState theme={'green'}>عادی</GridState> درخواست فرآورده از نوع عادی می باشد.</p>*/}
                        {/*        <p><GridState theme={'red'}>اورژانسی</GridState> درخواست فرآورده از نوع اورژانسی می باشد.</p>*/}
                        {/*        <p><GridState theme={'red'}>خون شسته</GridState> درخواست خون شسته داده شده است.</p>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className={'Help-block'}>*/}
                        {/*    <div className={'pad-10 fb-20 dis-f'}>*/}
                        {/*        <h3 className={'help-title'}>عملیات:</h3>*/}
                        {/*        <p><GridButton theme={'view'} title={'مشاهده'}/> در صورت نیاز به مشاهده درخواست می توانید از این طریق اقدام کنید.</p>*/}
                        {/*        <p><GridButton theme={'edit'} title={'رزرو'} icon={Resource.IMAGE.PACK.HIGHLIGHTER.BLACK}/> در صورت نیاز به رزرو فرآورده و یا مشاهده رزرو‌های قبلی بیمار می توانید از این طریق اقدام کنید.</p>*/}
                        {/*        <p><GridButton theme={'accept'} title={'پردازش'}/> درصورت نیاز به آماده سازی فرآورده، ثبت ناسازگاری و یا تحویل فرآورده‌ها به بخش می توانید از این طریق اقدام کنید.</p>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            button: React.createRef(),
            modalAwaitingRequest: React.createRef(),
            prompt: React.createRef(),
            modalOrgEmerRequest: React.createRef(),
            modalRequestProducts: React.createRef(),
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }

        if (props.location.hash === Resource.HASH.AWAITING_ORG_EMER_REQUESTS) {
            this.buttonClickHandler();
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Group className={'PageOrgEmerRequests-group mar-10'}>
                <GroupHead title={'درخواست‌های اورژانسی بیمارستان‌ها'}>
                    {this.perms.ORG_EMER_REQUESTS.AWAITING.VIEW && <Button refer={this.ref.button} theme={'blue'} onClick={this.buttonClickHandler.bind(this)}>درخواست‌های در انتظار تایید</Button>}
                </GroupHead>
                <div className="pad-4"/>
                <Grid  refer={this.ref.grid} id={'orgEmerRequests'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <Prompt ref={this.ref.prompt}/>
            <ModalAwaitingRequests refer={this.ref.modalAwaitingRequest} onSuccess={this.updateGrid.bind(this)}/>
            <ModalOrgEmerRequest refer={this.ref.modalOrgEmerRequest} onSuccess={this.updateGrid.bind(this)}/>
            <ModalRequestProducts refer={this.ref.modalRequestProducts} onSuccess={this.updateGrid.bind(this)}/>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        OrganizationOrgEmerRequest.list()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    buttonClickHandler() {
        this.ref.modalAwaitingRequest.current.open(null, Resource.HASH.AWAITING_ORG_EMER_REQUESTS);
    }

    deliver(row, props = {loading: _ => null}) {
        props.loading(true);

        Org.deliveryRequest({hospitalRequestId: row.hospitalRequestId})
            .then(data => {
                props.loading(false);

                this.updateGrid();

                new Notif('فرآورده تحویل بیمارستان داده شده.').show();
            })
            .catch(message => {
                props.loading(false);

                new Notif({message, theme: 'error'}).show();
                console.log(message);
            });
    }

    ready(row) {
        this.ref.modalRequestProducts.current.open({hospitalRequestId: row.hospitalRequestId, ...row}, ModalAction.VIEW);
    }

    view(row) {
        this.ref.modalOrgEmerRequest.current.open({hospitalRequestId: row.hospitalRequestId, ...row}, ModalAction.VIEW);
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings,
        base: state.base
    };
};

export default connect(mapStateToProps)(PageOrgEmerRequests);